export const FETCH_REQUEST = "FETCH_REQUEST";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_ADD = "FETCH_ADD";
export const FETCH_ERROR = "FETCH_ERROR";
export const GET_FRIENDS = "GET_FRIENDS";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const TOGGLE_AUTH = "TOGGLE_AUTH";

export const GET_TOKEN = "GET_TOKEN";
export const SET_TOKEN = "SET_TOKEN";
export const REMOVE_TOKEN = "REMOVE_TOKEN";

export const DELETE_ERROR = "DELETE_ERROR";

export const UPDATE_REQUEST = "UPDATE_REQUEST";
